import { Undef } from 'types/UtilityTypes';

import { QuotingPortal } from './interface';

export const KewillHostname = 'app.kewilltransport.e2open.com';
export const KewillSubmitAction = 'kewill-submit-quote';
export const KewillCanSubmitAttr = 'data-drumkit-kewill-can-submit';

/**
 * Checks whether a URL belongs to the Kewill/BluJay Transportation Management portal.
 * The portal lives at a single base path; tab and view changes happen via frame navigation
 * without altering the top-level URL.
 */
export function isKewillUrl(urlStr: Undef<string>): boolean {
  if (!urlStr) {
    return false;
  }

  try {
    const url = new URL(urlStr);
    return (
      url.hostname.toLowerCase() === KewillHostname &&
      url.pathname.toLowerCase().startsWith('/tms/servlet/')
    );
  } catch {
    return false;
  }
}

export class Kewill implements QuotingPortal {
  submitAction = KewillSubmitAction;

  canSubmit(tab: Undef<chrome.tabs.Tab>, html: string): boolean {
    if (!isKewillUrl(tab?.url)) {
      return false;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.documentElement.hasAttribute(KewillCanSubmitAttr);
  }
}
